import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { BookCategoryForm } from "../BookCategoryForm";
import { CreateBookCategoryModalProps } from "./types";
import { useCreateBookCategoryModal } from "./controller";

export const CreateBookCategoryModal = React.memo(({ modalRef, onComplete }: CreateBookCategoryModalProps) => {
  const translate = useTranslate();

  const { methods, mutateAsync, isPending } = useCreateBookCategoryModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("book_category_admin.titles.create")}
      onConfirm={mutateAsync}
      methods={methods}
      isPending={isPending}
    >
      <BookCategoryForm />
    </Modal>
  );
});
